import { render, staticRenderFns } from "./ManageDepartment.vue?vue&type=template&id=6f09bdfe&scoped=true&"
import script from "./ManageDepartment.vue?vue&type=script&lang=js&"
export * from "./ManageDepartment.vue?vue&type=script&lang=js&"
import style0 from "./ManageDepartment.vue?vue&type=style&index=0&id=6f09bdfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f09bdfe",
  null
  
)

export default component.exports